export default __webpack_public_path__ + "static/media/rank_bg_pc.239eaf2f.jpg";